import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PageHeader({ eyebrow, title, description, children }) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        {eyebrow && <div className="orbit-eyebrow mb-2">{eyebrow}</div>}
        <h1 className="font-display text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
        {description && <p className="mt-2 text-sm leading-relaxed text-muted-foreground sm:text-base">{description}</p>}
      </div>
      {children && <div className="flex shrink-0 items-center gap-3">{children}</div>}
    </div>
  );
}

// Empty states always explain: what's missing, why it matters, what to do next.
export function EmptyState({ icon: Icon = Compass, title, whatsMissing, whyItMatters, action }) {
  return (
    <div className="rounded-2xl border border-dashed border-border bg-card/50 p-8 text-center sm:p-14" data-testid="empty-state">
      <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-muted">
        <Icon className="h-7 w-7 text-muted-foreground" />
      </div>
      <h3 className="font-display text-xl font-semibold">{title}</h3>
      <div className="mx-auto mt-3 max-w-md space-y-2 text-sm text-muted-foreground">
        {whatsMissing && <p><span className="font-semibold text-foreground">What's missing: </span>{whatsMissing}</p>}
        {whyItMatters && <p><span className="font-semibold text-foreground">Why it matters: </span>{whyItMatters}</p>}
      </div>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Button asChild data-testid="empty-explore-demo-btn">
          <Link to="/app/assessment">{action || "Start your assessment"}</Link>
        </Button>
      </div>
    </div>
  );
}
